<template>
  <v-container fluid class="main-container">
    <div class="text-center mt-12">
      <h1 class="font-weight-bold text-h1">생애연표 과정에 오신 여러분을 환영합니다</h1>
      <p class="text-h5 mt-3 text--secondary">
        ☕️ 삼성금융컨설팅센터 카페로 이동합니다. 👉
        <v-btn href="https://cafe.naver.com/sslife7" target="_blank" text color="primary" style="margin-top: -4px"
          >카페 바로가기</v-btn
        >
      </p>
    </div>
    <v-row v-if="klass.length === 0" class="justify-center mt-3" style="max-height: 80px">
      <v-banner width="600px" height="60px" single-line outlined>
        <v-icon slot="icon" color="error" size="36"> mdi-alert-circle </v-icon>
        현재 진행중인 생애설계 과정이 없습니다.
      </v-banner>
    </v-row>
    <v-row justify="center" class="mt-8">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="6" v-for="(k, n) in klass" :key="k.id">
            <v-card flat outlined class="mx-3" tile>
              <v-toolbar :color="k.color" flat dark>
                <v-toolbar-title>{{ k.title }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-row align="center">
                  <v-col cols="6">
                    <div class="pt-3">
                      <span class="text-h4">{{ k.age }}</span>
                      <p class="subtitle">대상연령</p>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <img src="/images/samsung_financial_network.jpeg" width="100%" alt="Sunny image" />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-list>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-calendar</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="title">{{ k.openAt.join(' ~ ') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-card-account-details</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle class="title">{{ k.time }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item> -->
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="title">{{ k.id }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-file-pdf-box</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="title">교재 다운받기</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon small @click="downloadFiles(k)">
                      <v-icon>mdi-open-in-new</v-icon>
                    </v-btn></v-list-item-action
                  ></v-list-item
                >
              </v-list>

              <v-card-actions class="pa-4">
                <!-- 버튼 비활성화 -->
                <!-- <v-btn
                  :color="k.color"
                  dark
                  large
                  depressed
                  block
                  class="title"
                  @click="login(k)"
                  >시작하기</v-btn
                > -->
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-spacer />

    <v-dialog width="600" v-model="fileDialog" :key="f">
      <v-card>
        <v-card-title
          ><v-icon left>mdi-download</v-icon>교재 다운로드
          <v-spacer />
          <v-btn icon @click="fileDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mb-3" />

        <v-card-text v-if="fileList.length > 0">
          <v-btn text @click="downloadAllFile">
            한번에 다운로드하기
            <v-icon small right> mdi-download-multiple </v-icon></v-btn
          >
          <v-list dense>
            <v-list-item v-for="file in fileList" :key="file.url">
              <v-list-item-icon> <v-icon v-text="getFileIcon(file)" /> </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <v-btn text small @click="downloadFile(file)">{{ file.name }}</v-btn>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-text v-else>
          <v-alert type="error" border="left" outlined icon="mdi-information-outline">
            등록된 교재가 없습니다.
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
//https://notefolio.net/8d31e97228ef51cbce85324a2296a8f2ac002664/77290
//https://pgnqdrjultom1827145.cdn.ntruss.com/img/a3/1c/a31cb98b3c26b1703f69a9be93a722902d2a50e9fbe1a4208bdb0477a0e79a60_v1.jpg
//https://pgnqdrjultom1827145.cdn.ntruss.com/img/a3/1c/a31cb98b3c26b1703f69a9be93a722902d2a50e9fbe1a4208bdb0477a0e79a60_v1.jpg
//https://pgnqdrjultom1827145.cdn.ntruss.com/img/23/2e/232e29058dba803880780b295459738a988c1233e16471af786fdcd76300200b_v1.jpg
//https://pgnqdrjultom1827145.cdn.ntruss.com/img/64/d6/64d6fa92e9e6c77518bf235b1e7616e179d574a00858cf16b1b66765d687e230_v1.jpg
//https://pgnqdrjultom1827145.cdn.ntruss.com/img/f0/ff/f0ffaa8b6c5034a186e615301829c468cd9ceb3ee2b6b2972ff844defd1f564a_v1.jpg
//https://pgnqdrjultom1827145.cdn.ntruss.com/img/22/61/226111030a2c88f8e51966fb7a860ec0a21792154fdbf8deeff24deea1e4daf5_v1.jpg

import { mapMutations } from 'vuex'
const contentType = {
  txt: 'text/plain',
  zip: 'application/zip',
  pdf: 'application/pdf',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  hwp: 'application/haansofthwp',
}
const fileIcons = {
  html: 'mdi-language-html5',
  js: 'mdi-nodejs',
  json: 'mdi-code-json',
  md: 'mdi-language-markdown',
  png: 'mdi-file-image',
  txt: 'mdi-file-document-outline',
  xls: 'mdi-file-excel',
  ppt: 'mdi-file-powerpoint',
  xlsx: 'mdi-file-excel',
  pptx: 'mdi-file-powerpoint',
  pdf: 'mdi-file-pdf-box',
}

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      klass: [],
      fileDialog: false,
      selectKlass: {},
      f: 0,
      fileList: [],
      contentType: Object.entries(contentType).reduce((acc, [k, v]) => {
        acc[v] = k
        return acc
      }, {}),
    }
  },
  async created() {
    this.fetchClass()
  },
  methods: {
    ...mapMutations(['setClass']),
    getFileIcon(file) {
      return fileIcons[this.contentType[file.contentType]] || 'mdi-file'
    },
    async downloadFiles(k) {
      this.fileList = k?.attachedFileList || []
      const klass = await this.axios.get('/api/dClass/' + k.id).then((res) => res.data)
      this.selectKlass = klass
      this.f++
      this.fileDialog = true
    },
    login(klass) {
      this.setClass(klass)
      this.$router.push(`/${klass.id}/login`)
    },
    async downloadAllFile() {
      if (await this.authorize()) {
        this.fileList.forEach((file) => {
          this.download(file)
        })
      }
    },
    async downloadFile(file) {
      if (await this.authorize()) {
        this.download(file)
      }
    },
    isVerified(pwd, hash) {
      const hashCode = (s) =>
        s.split('').reduce((a, b) => {
          a = (a << 5) - a + b.charCodeAt(0)
          return a & a
        }, 0)
      const hashed = hashCode(pwd)
      return hashed === hash
    },
    async authorize() {
      const pwd = await window.prompt('파일을 다운로드 하려면 강의코드를 입력해주세요')
      if (!this.isVerified(pwd, this.selectKlass.hash)) {
        alert('강의코드가 틀렸습니다.')
        return false
      } else return true
    },
    async download(item) {
      this.axios.get(item.url, { responseType: 'blob' }).then(({ data }) => {
        const href = URL.createObjectURL(data)

        // create "a" HTML element with href to file & click
        const link = document.createElement('a')
        link.href = href
        link.setAttribute('download', item.name) //or any other extension
        document.body.appendChild(link)
        link.click()

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link)
        URL.revokeObjectURL(href)
      })
      // if (k.attachedFile) {
      //   window.open(k.attachedFile.url)
      // } else {
      //   alert('다운받을 파일이 없습니다. ')
      // }
    },
    async fetchClass() {
      const k = await this.axios.get('/api/class').then((res) => res.data)

      const kk = k.filter((c) => {
        // console.log(new Date(new Date(c.openAt).getTime() + 24 * 60 * 60 * 1000))
        // return new Date(new Date(c.openAt[1]).getTime() + 24 * 60 * 60 * 1000) > new Date()
        return c.isActive
      })
      for (const klass of kk) {
        // const consultant = await this.axios.get('/api/consultant/' + klass.consultantId).then((res) => res.data)
        // klass.consultant = consultant
        klass.year = klass.year ? klass.year : '_2023'
        klass.age = klass.age ? klass.age : '_기타'
        switch (klass.groupTitle) {
          case '삼성화재':
            klass.img =
              'https://scontent-ssn1-1.xx.fbcdn.net/v/t1.0-9/66382356_2590578757627170_3532237711899361280_n.png?_nc_cat=101&ccb=3&_nc_sid=174925&_nc_ohc=HTWZye0kjJYAX-I0U_i&_nc_ht=scontent-ssn1-1.xx&oh=be6c87bdf6934c251bde5a76b98a08b8&oe=605F153C'
            klass.color = 'secondary'
            //'https://pgnqdrjultom1827145.cdn.ntruss.com/img/a3/1c/a31cb98b3c26b1703f69a9be93a722902d2a50e9fbe1a4208bdb0477a0e79a60_v1.jpg'
            break
          case '삼성증권':
            klass.img = 'http://www.s-d.kr/news/photo/201602/17273_14096_4427.jpg'
            klass.color = '#002d55'
            //'https://pgnqdrjultom1827145.cdn.ntruss.com/img/a3/1c/a31cb98b3c26b1703f69a9be93a722902d2a50e9fbe1a4208bdb0477a0e79a60_v1.jpg'
            break
          case '삼성카드':
            klass.img = require('@/assets/scard.png') //https://img.hankyung.com/photo/201812/01.18449246.1.jpg'
            klass.color = 'accent'
            //'https://pgnqdrjultom1827145.cdn.ntruss.com/img/23/2e/232e29058dba803880780b295459738a988c1233e16471af786fdcd76300200b_v1.jpg'
            break
          case '삼성생명':
            klass.img = 'https://i.imgur.com/broLa6f.png'
            klass.color = 'primary'
            //'https://pgnqdrjultom1827145.cdn.ntruss.com/img/64/d6/64d6fa92e9e6c77518bf235b1e7616e179d574a00858cf16b1b66765d687e230_v1.jpg'
            break
          default:
            klass.img =
              'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAj8AAABXCAMAAADcStQbAAAAk1BMVEUDTqL///8ATKEASqAASaAARp+3zOX7/v41b7Pp7/cAR5/L2+08c7XD0+e/0+h3m8kIWKgZYq3x9fqovtsAU6ZskcPV4O7u9Pl9ncre6PP3+v0AQp0AUaVOgr3K2Ori6vQzZq2IqdGWsdSuxeCZtdcdXKlbisFEerhZhL1BebmCpM6OrdQoZK1mj8M7cbQ1crZolcfm0GbUAAAbWElEQVR4nN1d6XriurI1kjBgJgMOYIchzBAgnfd/uuuBwaVakk12t7vvqT/72x1byKWlUqlGp8YoaoXu9vP7ePjVjKkz3/dXo8VyEvEn/9cpGi4Xo+n10Bz4geME/qB52H9uu63h/z4vGtGkFXY3o+36fF5vR+4ixF/taP+/7K7fOruZVEpJKWKSUnnKCS7z6WY8rGLm/wo1ws3qOAiE50nhCCem+D/S80RwOX66YeNvz+8PUjR21/3Dhx/MRAoE4cyCXXM/3XaXOoYoftqfh53z4NeThBOPE3xcN63SU+i5hbQZF40yLBwlBG81uoU/XLj6UW/65UsldU6kvPCk35kuCkYYb8APT/SHwOx6+kO3GS2s38R5OUGPlRAB4eit6TteAhuRfX0sRpKto2a7Q39DR8jhJ+rt/fglxrAHSSWa55IIWvhkHIHI2xctY3sgjbNJqd4Hb7Uu+bfQD/cL2Bi5h1gEW35XxNvpurAeY/06/+H3Hn2m0Vccn34Xjtfq2CakTmwy44CPLdr2D69F7f5OSAMKktMohkB+zz7w0xhfHf4x+gCy3tyUOsVGdYyZPMmPIj2ivZP2IdQcveUXvOW9Wb+hsbgK21rdeOH506VlFISfOscPZ5MZPzZe+gwZMX44vwrw0+77dYsEySAwOD+/+46faNssRE9Kyp+WEUGf9eKhhI9OnzwtdgVzkk0Awc2s4C07fhrbSzF60vl7c8sh1gccQPjhXDHhxyaLhbPVX0DyR1rxE40+yoBAiLl7f+WGn+g7KDgp8m/btt2N5iWWQHi9glG0UxAMsQMQXNt3UAF+Jp9OaVbID9c4TrX4cdSbvpPGnHl2/LT6JUEg1G51eyfDT+v6Xkr4ZG/XD0VyoxYVKS4pva8LhukW4cdxOASjftFve1esoqaseCsnhzNSvhFAFeNHNnUNesyFtxU/4ckr/eXivZ+xMMXPpF+0Y7VZvJn5f5t7UGYg77tgmG7RMEKO2EuTYyF+jsb5N/qvcCIGUNO0lyrGj+NvtBdexM/yWELlyNE05WGKny0/Ka0kAnbYauR6/CXOKnUquIAV4sdRK/ZSeCKMBltDmfEzkq+xwlF9wyWgavyoT20i48Er+Bm+JkPuGEjws5iVPfDvJHcFppszY5647Nl+kJeCg7DHzS8BHUVd2fItLvknRMDPQHU0XQEKDQaMRMAlYEpV40d2tI8KX8FP4/wafOLfE8nRHeMnOnJhUUTe1DCP22ze2JCys/3gYChQoF3+UbtPOuyBQcH16QNHtkZG/AwLVSdOpsGqxo8TaJfB8MJeMOOnzcFW+OGnSYof13RICGkyJDlyYL3Etw5s6urY+9L/UTiGvXsnl58m/obCg6mNtS0RWt70m+OHgy6jBWd5Os/EiyMNy2da78rx453pC+HHC/j5fk35SQdLVs+pDa8GngWDZvPDd6BCIJR15cd86uptye/08tOuAAE1yu/+Itblnc7taEp+Ro36bBB1wBaIiD+azlL4zdPh9OFj3QjawP8CfuQv+sIr+GkbNeDU7Gj4wXgbOrU23HNqMHXHy1bYXR/gu+rbtvIuV/1jqFw5fvb2i9wG4GdMh2Hqx5CeV36Xg0KeMH5aF8QpeflctKJatHTfoDlTXiArKsePI6k2uWyW138+4cYRUvmDy8U3WOOF78b4GSFrrWx273ppOEVmAWnYwhnxC50QW2CTlh27Aj1C+Dnnv0aIs6ZAt8gxKQchX0jZwZMHx2XycO/+C8MR3Gsz+BFV4IdOt0630rJZWv4sTwghQnVW7qLd7m33AUSQnEYOlNnyI6eLRVxuJE9YLFHaEZLOZebWtu/sXy92LzbHj/DHLtVv9PszNXvEMhbhB8MWOV3ELr/m8HpfhzbEKvBDt75Hz4Ql0zeN+OkhwSpn59ZtwMjlZ2HyRGfiQFjPiH0HTCRmq9lyX2vxK0+87rUeww83elHaIvxQgDBduEeWWL5FAD9fGD8HsFHqn+QR/mWO8w6tYRXgx++TrSSpLXPJXzDgp4E8PmKXF2chvxElU207IYCe/CCXmugToNO28iE/eeVHqxZyz4BcWxXoNcIPZaT80M6iNT3eVmAhJTYaD9HppEU8bIB3o75Co1WAn6BHbt2COlNap7L4Gb6BaTgrIth7QDcUYuQswO1dHal/kV6Zs1dNZrOEgNs8iU+ZcEuex7x+hCB+hleP/IN2BH7r6jXAzwfED9xKAzpB4BTQRdSNKsDPrE1ZIciSl8cPMLfEMpoaRiJuBkm+3NlwE6+jtBvpAlgyZxYXxoiP6V3jf+cKHTOaUloh/DRWZNPpNiSiCordogbuXxdoPl/MOIdkR2M1/wbDBb4K/WdBDaz0LG/x49iAH2BpdJRuIe6B71FXZwuOPk9jSJvLLit+wG3QW9WQ8gDjL2wDJXrUiNzu0pGfNCQeiETTmXL5g/HTA6yQJ/rMhB/Nfw0/wukuaajlLi+LW9zeZsAPMD5zx/SSf44j584aiCVNkdc8Stn4NvwAJbOeqEtTjqvAooab8ENvC6lkM32md4zArUoMIH6At8QRTfrMv4UfN9IOsPyiTErjpwv0ExYYM0Gne8c5o8v5nJr1XsRPBBwvqRoKzDl1awgQP3qSmMUxOUM0sysVs8nSAvxg9y/ET0DV838MP5qzRh1zCtAEiHuMHxfoMIH+JLpdyCbED7V5pG4hPZDW4fGSDwq5HiEGyTJ0+R806aERxg8N8BE+Ufbplf999B/x49Tpd06aQLb+NfxsNO8BiQiecL+4AT8bYNVi+AFSIZbOUP9xBA0QWww8pZMw4wd4reSvZJFBRIrutKHEdf6EQ1GfXtEJGOiRV29D/PgQP11siSfPTn7NAp3UX7p/CbHRTW1eTmspjx9wLggWj2/AjwuDzWcrwjSX5TJtYOZVRjz4x5GpYAVXCOHbPGDfnAOJwk2v9e95FYoay0XQwviBZm8QMJw8vM+fYI1wzAneIavAT4wWGreTj+gc7sueXyM+VYQfpB06BqbVVz9PNt1zOKvU0Y6+yJpRwj0nwl/qF6V6Pm5hSYweMtF+V5w7eqhMRhPo3RLevDDPEVFF+KEpBvLyxPIQcO+/4GfgSZ3UxUEGjeT9Wb8wSN5AQyBlRCpXgV9Md/pRAnjbxfgJyQW+no+ippEjal+D+DEsEU4aEerpQX2BqsDPlnE7d5+ldtbsjf+Cn/OU09kBKL3RyXq1NlMIBF32WcjPgo23N0IGo6V+FKt5bnXp3T4VTUj+4CUyJa3JwbkoYYBTBfiRW/Y7YvV4YciDQP8LfmoRIke7AeZGUKpfnCcOCMQzyks2mw3/E7ly6gQsGAl+qFySzZyCQqJRkgsuVMcMVqcuZETyE17TfVUEVYWfnqI3+McB9rvxA8mptaFrPh3D+1iXSBXUCQDyHjDRBXFlX5afABb4FD9EpOStrhH1baR2wvL4mcAwmJRU8GZPd2dUgf9CJcYzqrXJZ0RMRfgZvpnj2qQzL5funqNoCuyUt10xBiFNthAgvp5il4xEDRbBMxSAepIz7xrAz8wQPACNGbcflpfpSxphVfipEZjk3IERH/xP4Mee5ClnB/e1QwyYPR15C/JaggibwBIIAjTxFD/k0iicpw2bepJlmqcMcolM+FmiKJfHaOqyegFBVeAnvXlSD7i63jd8VfgpqHWg1LX7igwKv/i07yuMrpTO2YzPXwb8TKgHY/o4Wej1K4suAvgx5n241oRp6Q3WpRFUBX5W6TdTZjxy6lAU6B/Bz9JaWSbJln/DnwQJ1cy4Bws1PoEPxVKMx4SfiCjQ6hmFT2VpJtpAEJERPyBYkU7WOW1LVkCqDD8TajIVd9laGX5q3YG9WkaMoH5pG9oIlA15+NPABV7NjQvSAOrSLsFK9EnUnGc6BVGMbqoVwI/Z+TLp2IsICDk7bUop0hXgx8tsH9sZPcBuL0TTsvFj/xU/Nbeo4o2oByXtiY1PoP484mFdDi5DME7KAZ6xKgaprCEgFYPHt2q4Sqe85eeXxXkXzgsy4IXyDmUu8xXgp57FeNEbtBzc5HnEhf1P8NMY2uhW/8f1i5KLhNcpJbmB1TMXZdgG+oXBmFeDLjuZ4YcaAvzHsqBzDeHHEjUyLixdJFTQL96dVcifzPFPM95E/TY3asvI/vYD/IT9Nwvd64+NdoVlb1QwL6EGoTBLtb/v1yWIdDMLAxBycsMP0Rmf6kxEFKZbCCbHT6xYW74gPNWLWCFk81x0p6gOP5qF/e4P/E346e643+tJj/qHC5S8os931i+0JyJ/7LPawpDHdLNo2ScNeTWMG35oCJB3v4Atyb0+c7oh/Kiz6SfTwYuLsQnp/eraD7Eqzq+b529MdDZ1i/4DJTV+gh8Q/J6nxyDhW3HdNqFORdagDTDB5WKwuEfUUQfTQkxAvNAlZQ7VDR8+kDYRojcvO8LPyvoNw+2luAiZ2p2tm6kK+XPDDw2tuDuLomrxU5usd4UFzITcFbgSgbcyn6AJsl2zKzlkGXB3ZPihThLZvM1pk89QFINM4wf48WxO21pSgfXkFW4mOTvaLqUV4ofGSd1Tqxpr5kj6o/iJt+9cFpbfks7eehEDAkbUn2+AxTQXJW7xs1BeMr2DFPl5hG0SS6i8lUQG3KnbyxclP/25Ky4F5FnKZ1aCn/tV3SX/rLLyoNXjpxatv4rrt3m85E5uBBSllosx7KL8TZM1z4KfcV61FuLGcgLe++78EX7izbQPCnmh/K1RCarCfnjHD80wv6XXNrgj+0/jJ16XflB4iHlfZpfnEqSzyl9PnSkEfzeGAC2BtegjwyINm/IyBSsi2vk9tQPhx6iy56i17RRqQdI33uSqwM/+9jet5OwtvGDLQpP/PH5qUe+kitgmO0bzRw+8+/jMmt5b4Pb3o0EnB2C746dGzEw3PNA8yvti/RQ/MX4/CzeTNOZxV4kfLbDqbrj4G/iJEbQ54KJjuQkajzDuLKDaagTMBEltBUghH0vcVWXiFb21MSDer4dSBLILvDfD9HUa94tuYtJUSKIK/efRvWGsHWDpIc8rO1WCn3iqhWqQMWoQ3a9EbouCypqmdKwYPyji/4Yfl6jKH5xh8utm4UP4sWad5SnqXgM7gkAFxowTFcifB360ChpiwdiR/ftP8HPvQYI/H7MtXAVWI2wWOskJBf84s7y6tAIPmEKAxhzFt60V/y2fi3iTNcTg8ejuA7ijSuMn/qTNoW7dTfnjOUeV4keLfMtUP+7J/pn8UVmuBf56E9vC/sDGNYXrj4GajUkJudwToN6HEAZz8JhrHw/8kA4JYpYsDA2YkvdBNwA/hZ2j8hRtvmymVfEO4V8Ffg5PVmlFtZLv2/wW/ETLMCVU5MUx46fW6L5ZJLcQernzlFAhNHXKqzeoJYo0VAEaA8/VHT+1ee5YynxoJBczKZiXEcCPZ9LYDbRc27oTeXNkUq0CP8/iIFSvzDSC34OfB82BamvBT1IusmO2wuIaXiD4J1Y28q5GUNr3ER6tU5sXvHtoNdRWmKYQEyXyGdQBiriSlJ8y1Bh/m7ujCdhEpQL85IvL0JSCWaJy8myXavETz3lljOtAnUuQyzep3JtfLBQCbVJBEX46d/yM8id+anIlN4Vb8E8N48focjNS5J6MwfW5ANonVYGfzlOMtsnk0q4cPJGqavzEV+KjIT0s1k/50xNQi1yr9DIB+YrC7/Gxkh+34YfEyaZtDMh+U48SEKCcww/wk24mgw4JixlXgZ+cYZYaVNPqcy4r61M9fhIbGhZB4sLXYAnCMxwq3VF6jykeGRRsfeInzIcApRJsTUqZPGoBukCL4t1CS1C0wbneOISyCvzkuy+S0Mv0SP0n8FOLRlhup5UMNAIFWmJFhHo7uFdPP+IeZMUP1ZZ3XRovnmkAKSH8dFD013CCKD+zRQe3mkEKUAX4EXn80NNKxdunx64qfwA/vwA150Q33hjqUnAvGKrApBdbBjnMsQINo/lcgJ/TI73pU4PL8KAB6j4KCKhtgt+bXHcDTrTUC24iAOVnFfInfwRQ2Z9ceivBDwpK9DR5PIJZUe9808FieNrlCuQwxxsJhmJtbPgh7h0hzo1W/maXK9HrciuSQPhpHT3Q1/idribO9kbxsFXjh/pQk/XnnP4D+EGk1Q9HmYwxAbMZCP5hjV3RBV6wamkpAfyoJ35Ik5b4V4gJTc2fzwEr5AVYbFqw72VdW80R6naFKohXgR9SnForS7v+d/ADK2untQUpDZF+KTXeIjumoR3UCODn8MAFAWL876T7Sc7D3vut+JnswVMe6ENVOX600kenKvCDW8cx/EDBwts+hMB6SLynCcF2LDiGnjdcyeOnNSfn1XKd50Iu5BrhZ/Bj/MB6N/Upxw8oVvzb9edd/hjWavnOWtxzbqqfyU2j5fAjyuJnDTYTlz9dlPzLaqWgdPucJzBHdvw08j5n4Y+J6z+3Ul2g/6CQ65L44bfiJAKO4we11Prd+NFKzxLGei4vC27CD7j2cI0C5MWJHf9GB+EH+JAAfhDKeIV5gIpn0iQdz4qf2pl4wFxyLoonQBB+/J/jB6VAajXwU0LbhOMHnOU7HN1ZXHw0JA94fV6224CfHhAjHD/AcSA+4AlWEj/s/sXLpT5Cc3IE7DHxTJA3DVTuyeOHKMbimt9tecsICLmG+MF94xl+ULkbBe5fZyR/NJZFoPaSoTg+xE9Aj2FSLkmeNuymYsAPKHmRlW7LEyhG4IiTAzuHseAMJDMYZ4coBTELJcgTaONk6MEGcoFy96ramGB/lg8IysfkLEAMagDwAxUz5113rYDyfAIVU9+ifjXac0OgjJvqAZTAD4mtEpdPVivfgJ8xSHpgJokWUG7V0eElCojx7UbgMqHV7a7h4B9aHTWlCPVqhX0MIH6eggWkpz4eWz1HQfiZAXtTBLpggVMa6c8oAA6Z7fVrwhh05pPYFob7D9JtsCCcnX2UvX+BTpcxNLQrBrikxd/jzMEa5Ct6ZaxFsov5L3pAs0TAQLd87w1E5AAVgkReGCsdEOnbBvIOHpcoNJKFumL/L1BZUGM1XTHgEe5J8xEczAJN3/TRCT0AOIBN/b/QyT2jrf3GoHGDI7cONA0qzWbsos5YzH+KOvEKVc7KCLkGrsAk8NpYOI1EVJfGD2xuKi6U5V0k65m+GFMIpKNwSKTHGBXuUoZ6Wuj8UpRp0aog59GAH1ApKLnSkP6Ve+SCCBa4/4UzIxGlEJ/8yo3aXDozzlpkGYFLAE5NL48fJFKz0fJt6QB++NmbEJIYiWKeXySksfAerCnTkDYo8vliUGEXwtDSE+HH037XXn7PiB9sVJe78334Ru+AYCKbLVP/Amf9XKflFb3s6UHLSLLf6z3R2cJurSAEqAg/bWy+Sk7D3B4ujZ8h9G0JkUvYbu2R8q/0HtAJRaCQVjLad5g+3Bi6MD0RMiL9aYCfuqZChPZKhEb8gLq4ydPq8j3qLhbu6jCDsfDxdzugy1j6rrN3w2HUiFrhhhfETIjZBeHkUaRNFyw77CcG7AEEP0tD6WraCHSM8AP5+A3lmfAu60U4mUyW7S2sbicCmIwCusYmD6vddT3ajFYHQ0/1k6GqRxn8RMCeRF4w4AdfHeLH6/VZEMg6Dt1NgowcUCXm9q7/de1P+8em4TtZD+wFCvPwrhw/0JuG4vFBKTNvn3tsaFCgaXNfiB9o44UNwNLHB6fj9Xi44DQMeYGrEsJYjwSPKghmyiApPFNqPsSPvgag8yx5wYCfmmvLtTGG7R6WNQcve/ZjMmn0ZWACD/lCgT3QMtsCt1ZH7vlBB/Cj8vhB/VjSyRH7A8KPgofE0FR/XgipYm4Y4FUHe6SWFps1L4r5L8ZiJAg/zIRiNmmkL5jw0yhRPYzTNqmfaVoEO3ETYwN2MpwBx/oQJRlyeYaLTe1JyAJeB9XJj1UeP1iPLCRlKCcxti8mHgsnI9ZK4gfebXMvmPBT6xYWwORTTVQJJ0k9e/0zHcVSDqD5FjoDI3QB08NcDcyg+EHpZk4SspaXZRA/uHBPCyG7iFAiQUb2wuxw5gbnaQ3bfzh+QH2lHJnxE61enWrmp0vin1eF9SIZSd53e4KOe2iMB4XVnLSZp0YN3oDRUeSswPeGR7uE20OoJIghY7q4Di1ghbEYSQvZ3GwkFA4ETwdD+GE/PUbG/ef4Rvyk0ZcvfXbms0nwE0uOFwEkQNGJMfSkocyWsppSBKQBxQ+WF1pFV5BF73imphvb11lhaYC3MPY2wmPJq7k4YDn8NKzVhy34SQD0wlSln5mp0vyLsLDksTaNYMW3Cby8KMgQFAINTv4ITIvix3BfDYh2EwL8GEueRX37DYbzArDiQY3NS7pB/WApDQjxw0+79U/xUwuP5u5DOsnZrfBalr8z7rxyhMVSFqACBf8ANSn9ObQteU4Eup5T/KB+CCzkKEQVYY1Co9V/RQLJOjIdPqmxccofC/UvWz1OiB9+DYB7805W/NSWfVFcvTAlbze6Gclv+V+tgyi7UYQKYMcc0DU3vn7B8m4ohzkWavrmm4DHNPyAYIrEe0GeAVWoWCBFjqJ1cd3D+5Tl7lyUiNj7KrmrVfBmrQdcEj8t5BB/TthaN7/hfpRAkJDB9QH0e/5g63NQbt8J2cF7F6qyuLLPEKQ5g3g0iB+azQGVLs1lHgLnrwU/sXrWKbeZhFdYDTv5+b4p7TlPUn1s7RXtW1+8DjxIoYpWylwtXngFfRfCVbMAQcIL5rkGMo/806g794oVKOHNDJ14lj6Yt4edOVEflcR/1x1qrQ7gGJU/rWa9cKBQ8Jmx39K4uLOXjEo4ITy/XEuZoTt3TKbH21iyvivsqNGa8/RGVDfA/QBZkHcyVXp7UDReN4UnsRIohKrP9pu8mMzlLw9Hh5mymUyFVP6+a9hx4yaiI+bwCD680jm2Bw/RC26jjwaiXF3+4k9cbF3Dk6/pD4Q0C6H4bzJe8bJJ9MPe3jeYr0U8lnIGnyU6FaP0ajCDBszCvlOJ2U56/UsgVbzp4gnfKteJ5IuV8A9n7aNJ/nvU63/5UgH0xe97zu6wssC3AemVh0s99YNnXpjXk8Lt/hIozgsRHzVqdjmWb0SY0nj79rWbKaWehQRT/5AIBofPTcmWdJXRsD2aHk8fO98PZrNZEPi7S/Pwdt7wb9bqJ0ShuzpeAqESQSRu+0Mqz/Gb13X3B82Y/x/TpL2Zzi+Bo7yYGTLbgV6y4PPpqP16P/go7I0+r4fmwA8y8gedY7wmi+VPmqT/cWoMl+NubzNKye0uxi0obXn9jWi4XGxvHxpjz78059+fm3Hr1T7M/wsUTZaL0bm/P3SSM7Bz2H+vRt0lOjVKjjectJbj9qLbjRckXLaG0T+JnRfo/wCNASc6vInd2wAAAABJRU5ErkJggg=='
            klass.color = '#002d55'
        }
      }

      this.klass = kk
    },
  },
}
</script>
